import { createSlice } from '@reduxjs/toolkit'

const STORAGE_KEY = 'teacherAppTheme'

const getInitialTheme = () => {
  if (typeof window === 'undefined') {
    return 'samsung'
  }

  const storedTheme = window.localStorage.getItem(STORAGE_KEY)
  return storedTheme || 'samsung'
}

const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    current: getInitialTheme(),
  },
  reducers: {
    setTheme: (state, action) => {
      state.current = action.payload
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(STORAGE_KEY, action.payload)
      }
    },
  },
})

export const { setTheme } = themeSlice.actions
export default themeSlice.reducer
